module.exports = __webpack_public_path__ + "img/setup.735198f2.svg";